import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAuth } from "../../auth/AuthProvider";
import airtable from "../../lib/airtables";
import { setMessagesUnread } from "../../redux/app/actions";
import { teacherFieldIds } from "../../lib/airtables/tables/Teachers";
import { CollectionsResourceTiles } from "../../lib/collectiondata";

export default function CollectionsPage() {
  const dispatch = useDispatch();
  const { user } = useAuth();

  useEffect(() => {
    const recipientEmail = user?.[teacherFieldIds.email];
    if (!recipientEmail) {
      dispatch(setMessagesUnread(false));
      return;
    }

    airtable.messages.getUnreadForRecipientEmail(recipientEmail).then((items) => {
      dispatch(setMessagesUnread(items.length > 0));
    }).catch(() => {
      dispatch(setMessagesUnread(false));
    });
  }, [dispatch, user]);

  return (
    <main className="dashboard-page page bg-white">
      <div className="max-w-6xl mx-auto px-4 py-10">            
        <h1 className="flex text-5xl font-semibold text-gray-800 portrait:text-3xl lg:text-5xl md:text-5xl sm:text-3xl">
              Collections</h1>
              <p className="text-gray-500 mb-6 py-6">Browse through these popular topics. Each one includes a curated collection of resources you can explore and use in your learning spaces.</p>   
        <section className="bg-white rounded-[28px] p-6 sm:p-8 md:p-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {CollectionsResourceTiles.map((tile) => (
                <Link
                  key={tile.title}
                  to={`/app/collections/${tile.slug}`}
                  className="relative aspect-square overflow-hidden rounded-[24px] shadow-[0_10px_24px_rgba(54,36,81,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(54,36,81,0.14)]"
                >
                <img 
                  src={tile.imagesrc}
                  alt={tile.title}
                 className="absolute inset-0 h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/45 transition duration-300 group-hover:bg-black/35" />
                  <div className="absolute inset-0 flex items-center justify-center p-6 text-center text-white">
                  <h3
                    className={
                      `text-[1.9rem] leading-tight drop-shadow-[0_2px_10px_rgba(0,0,0,0.55)] sm:text-[2.2rem] lg:text-[2.4rem]` +
                      (tile.slug === "land-acknowledgements"
                        ? "text-[1.9rem] sm:text-[1.8rem] lg:text-[2rem]"
                        : "text-[1.9rem] sm:text-[2.2rem] lg:text-[2.4rem]")
                    }
                    style={{ fontFamily: "loveletterregular, serif" }}
                  >
                    {tile.title}
                  </h3>
                  </div>
                </Link>
              ))
              }
              </div>
        </section>
          </div>
    </main>
  );
}
